import React from "react";

/**
 * Composant de modal de confirmation pour l'exclusion d'une activité
 */
export default function ConfirmExclusionModal({ isOpen, onConfirm, onCancel, activityName }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          padding: "24px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            fontSize: "20px",
            fontWeight: 700,
            marginBottom: "16px",
            color: "#111827",
          }}
        >
          ⚠️ Confirmation d'exclusion
        </h2>
        <p
          style={{
            fontSize: "16px",
            lineHeight: 1.6,
            color: "#374151",
            marginBottom: "24px",
          }}
        >
          Vous êtes sur le point de vous exclure de cette activité : <strong>{activityName}</strong>.
          <br />
          <br />
          Vous pourrez y revenir quand vous le souhaiterez.
          <br />
          <br />
          Merci de valider.
        </p>
        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            onClick={onCancel}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "1px solid #d1d5db",
              background: "#ffffff",
              color: "#374151",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "1px solid #dc2626",
              background: "#dc2626",
              color: "#ffffff",
              fontSize: "14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Valider
          </button>
        </div>
      </div>
    </div>
  );
}
